module.exports = __webpack_public_path__ + "static/media/ico_reparo-oficial_new.20d52372.svg";